import { render, staticRenderFns } from "./btnConfig.vue?vue&type=template&id=768d6536&scoped=true"
import script from "./btnConfig.vue?vue&type=script&lang=js"
export * from "./btnConfig.vue?vue&type=script&lang=js"
import style0 from "./btnConfig.vue?vue&type=style&index=0&id=768d6536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d6536",
  null
  
)

export default component.exports